// extracted by mini-css-extract-plugin
export default {"textField":"EmailChangeDialog_textField__2US3G","annotation":"EmailChangeDialog_annotation__CqfwY"};